import list from "./list";
import actions from "./actions";

const affiliatesModule = {
  namespaced: true,
  modules: {
    list,
    actions,
  },
};

export default affiliatesModule;
